import styled from 'styled-components';

export const TableContainer = styled.div`
  z-index: 0;
  width: 100%;
`;
